import { StoredQueryModel } from '@ardoq/api-types';
import { crudApi } from './api';

export const storedQueryApi = {
  ...crudApi<StoredQueryModel>('stored-query'),
};
